"use client";

import { ArrowRightIcon, CloseIcon } from "../lifestyleIcons";

interface DrawerHeaderProps {
  title: string;
  /** Omitted on the top-level screen, where there is nowhere to go back to. */
  onBack?: () => void;
  onClose: () => void;
}

/**
 * Back / title / close, shared by every screen in the drawer.
 *
 * Figma drops the close control once you drill in (back only). Overlay tap
 * still dismisses on desktop; on mobile full-width, back is the way out of a
 * nested screen, close remains on the lobby.
 */
export default function DrawerHeader({ title, onBack, onClose }: DrawerHeaderProps) {
  return (
    <div className="flex items-center justify-between shrink-0 w-full">
      {onBack ? (
        <button
          type="button"
          onClick={onBack}
          aria-label="Back"
          className="flex items-center justify-center shrink-0 pl-4 py-3 text-gray-5 rounded hover:bg-gray-3 transition-colors">
          <ArrowRightIcon className="w-6 h-6 rotate-180" />
        </button>
      ) : (
        <span className="shrink-0 w-9 h-12" aria-hidden="true" />
      )}

      <span className="flex-1 min-w-0 text-lg font-semibold leading-6 text-dark-1 text-center truncate">{title}</span>

      {onBack ? (
        <span className="shrink-0 w-9 h-12" aria-hidden="true" />
      ) : (
        <button
          type="button"
          onClick={onClose}
          aria-label="Close filters"
          className="flex items-center justify-center shrink-0 pr-4 py-3 text-gray-5 rounded hover:bg-gray-3 transition-colors">
          <CloseIcon className="w-6 h-6" />
        </button>
      )}
    </div>
  );
}
